var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitMargin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_4000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 8.125C1.875 7.95924 1.94085 7.80027 2.05806 7.68306C2.17527 7.56585 2.33424 7.5 2.5 7.5H5C5.16576 7.5 5.32473 7.56585 5.44194 7.68306C5.55915 7.80027 5.625 7.95924 5.625 8.125V11.875C5.625 12.0408 5.55915 12.1997 5.44194 12.3169C5.32473 12.4342 5.16576 12.5 5 12.5H2.5C2.33424 12.5 2.17527 12.4342 2.05806 12.3169C1.94085 12.1997 1.875 12.0408 1.875 11.875V8.125Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.625C5.625 5.45924 5.69085 5.30027 5.80806 5.18306C5.92527 5.06585 6.08424 5 6.25 5H8.75C8.91576 5 9.07473 5.06585 9.19194 5.18306C9.30915 5.30027 9.375 5.45924 9.375 5.625V11.875C9.375 12.0408 9.30915 12.1997 9.19194 12.3169C9.07473 12.4342 8.91576 12.5 8.75 12.5H6.25C6.08424 12.5 5.92527 12.4342 5.80806 12.3169C5.69085 12.1997 5.625 12.0408 5.625 11.875V5.625Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5H12.5C12.6658 2.5 12.8247 2.56585 12.9419 2.68306C13.0592 2.80027 13.125 2.95924 13.125 3.125V11.875C13.125 12.0408 13.0592 12.1997 12.9419 12.3169C12.8247 12.4342 12.6658 12.5 12.5 12.5H10C9.83424 12.5 9.67527 12.4342 9.55806 12.3169C9.44085 12.1997 9.375 12.0408 9.375 11.875V3.125Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5H11.25",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_4000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitMargin);
export default __webpack_public_path__ + "static/media/profitMargin.a641cb939035bc8d0e780091c41b0c0a.svg";
export { ForwardRef as ReactComponent };